"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10CommonComponents = require("r10-common-components");
var formatSectionType = function formatSectionType(value, type, t) {
  var _value$;
  switch (type) {
    case 'type':
      return value.map(function (i) {
        return t(i);
      }).join('/');
    case 'money':
      {
        var _utils$formatMoney = _r10CommonComponents.utils.formatMoney(value[0].value, value[0].unit, true),
          money = _utils$formatMoney.money,
          currencySymbol = _utils$formatMoney.currencySymbol;
        return "".concat(money).concat(currencySymbol);
      }
    case 'date':
      return (_value$ = value[0]) !== null && _value$ !== void 0 && _value$.amount ? "".concat(value[0].amount, " ").concat(value[0].units) : value[0];
    default:
      return '';
  }
};
var _default = formatSectionType;
exports.default = _default;